(function () {
    'use strict';

    var CSS = [
        '@keyframes timesact-shimmer{0%{background-position:200% center}100%{background-position:-200% center}}',
        '@keyframes timesact-glow-pulse{0%,100%{box-shadow:0 0 8px 2px var(--ta-glow-color,rgba(255,255,255,.4))}50%{box-shadow:0 0 18px 6px var(--ta-glow-color,rgba(255,255,255,.6))}}',

        /* RIBBON span (backgrounded) — shimmer only, no size/corner changes */
        '[class*="timesact-badge-ribbon-span-"]{background-size:200% 100%!important;animation:timesact-shimmer 2.5s linear infinite!important;will-change:background-position}',

        /* ROUNDED span */
        '[class*="timesact-badge-rounded-span-"]{border:1px solid rgba(255,255,255,.25)!important;border-radius:50px!important;display:inline-flex!important;align-items:center!important;letter-spacing:.12em!important;padding:10px 24px!important;font-weight:800!important;text-transform:uppercase!important;background-size:200% 100%!important;animation:timesact-shimmer 2.5s linear infinite!important;will-change:background-position}',

        /* RECTANGLE span */
        '[class*="timesact-badge-rectangle-span-"]{display:inline-flex!important;align-items:center!important;padding:10px 28px 10px 16px!important;letter-spacing:.1em!important;font-weight:800!important;text-transform:uppercase!important;border:none!important;clip-path:polygon(0 0,calc(100% - 14px) 0,100% 50%,calc(100% - 14px) 100%,0 100%)!important;background-size:200% 100%!important;animation:timesact-shimmer 2.5s linear infinite!important;will-change:background-position}',

        /* SQUARE span (hexagon) */
        '[class*="timesact-badge-square-span-"]{min-height:64px!important;min-width:64px!important;letter-spacing:.06em!important;line-height:1.1!important;font-weight:900!important;border:none!important;clip-path:polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%)!important;overflow:visible!important;background-size:200% 100%!important;animation:timesact-shimmer 2.5s linear infinite!important;will-change:background-position}',

        /* CIRCLE span */
        '[class*="timesact-badge-circle-span-"]{padding:4px!important;letter-spacing:.04em!important;line-height:1.05!important;font-weight:900!important;overflow:visible!important;outline-offset:4px!important;background-size:200% 100%!important;animation:timesact-shimmer 2.5s linear infinite!important;will-change:background-position}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'timesact-premium-badge-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);

    function withAlpha(color, alphaHex) {
        if (!color) return color;
        if (/^rgba?\(/.test(color)) {
            var m = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
            if (!m) return color;
            var a = parseInt(alphaHex, 16) / 255;
            return 'rgba(' + m[1] + ',' + m[2] + ',' + m[3] + ',' + a.toFixed(3) + ')';
        }
        if (/^#([0-9a-f]{6})$/i.test(color)) return color + alphaHex;
        if (/^#([0-9a-f]{3})$/i.test(color)) {
            var h = color.slice(1);
            return '#' + h[0] + h[0] + h[1] + h[1] + h[2] + h[2] + alphaHex;
        }
        return color;
    }

    var TARGETS = '[class*="timesact-badge-ribbon-span-"],[class*="timesact-badge-rounded-span-"],[class*="timesact-badge-rectangle-span-"],[class*="timesact-badge-square-span-"],[class*="timesact-badge-circle-span-"]';

    function enhance(el) {
        if (el.dataset.taPremium) return;
        var bg = el.style.backgroundColor || window.getComputedStyle(el).backgroundColor;
        var fg = el.style.color || window.getComputedStyle(el).color;
        if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') return;
        var bgFade = withAlpha(bg, 'bb');
        var bgGlow = withAlpha(bg, '99');
        var bgGlow2 = withAlpha(bg, '44');
        el.style.background = 'linear-gradient(90deg,' + bg + ' 0%,' + bg + ' 30%,' + bgFade + ' 50%,' + bg + ' 70%,' + bg + ' 100%)';
        el.style.boxShadow = '0 3px 12px -3px ' + bgGlow + ',0 0 16px -5px ' + bgGlow2;
        if (el.className.indexOf('timesact-badge-circle-span-') !== -1) {
            el.style.border = '3px solid ' + bg;
            el.style.outline = '3px solid ' + withAlpha(bg, 'aa');
        }
        el.dataset.taPremium = '1';
    }

    var scanTimer;
    function scan() {
        document.querySelectorAll(TARGETS).forEach(enhance);
    }
    function scheduleScan() {
        clearTimeout(scanTimer);
        scanTimer = setTimeout(scan, 50);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleScan);
    } else {
        scheduleScan();
    }

    new MutationObserver(scheduleScan).observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();